import React from "react";

// React.lazy koji se može unapred učitati. Kad je modul već učitan (preload pre
// prvog rendera), komponenta se renderuje direktno, bez Suspense "praznog" frejma,
// pa prerenderovani HTML ne trepne prilikom pokretanja aplikacije.
export const lazyWithPreload = (factory) => {
  let Loaded = null;
  let promise = null;

  const preload = () => {
    if (!promise) {
      promise = factory().then((module) => {
        Loaded = module.default;
        return module;
      });
    }
    return promise;
  };

  const LazyComponent = React.lazy(preload);

  const Component = (props) =>
    Loaded ? <Loaded {...props} /> : <LazyComponent {...props} />;
  Component.preload = preload;

  return Component;
};
